import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { waLink } from "@/lib/api";

export function FaqSection({ faqs, content }) {
  if (!faqs || !faqs.length) return null;
  return (
    <section id="faq" className="py-24 lg:py-32 bg-[#0D130F]/60 border-t border-emerald-500/10" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-10 text-center">
          <span className="text-xs uppercase tracking-[0.25em] text-emerald-400 font-medium">FAQ</span>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mt-3">
            Preguntas <span className="text-emerald-gradient">frecuentes</span>
          </h2>
        </motion.div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border border-emerald-500/15 rounded-xl bg-[#050806] px-5" data-testid={`faq-accordion-item-${i}`}>
              <AccordionTrigger className="text-left font-display font-semibold hover:text-emerald-400 transition-colors duration-200">{f.q}</AccordionTrigger>
              <AccordionContent className="text-gray-400 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-10 text-center">
          <a
            href={waLink(content.whatsapp, "Hola, tengo una pregunta sobre los suplementos 365 Cellular Energy.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-whatsapp-btn"
            className="inline-flex items-center gap-2 border border-emerald-500/40 text-emerald-400 hover:bg-emerald-500/10 font-semibold px-6 py-3 rounded-full transition-colors duration-200"
          >
            <MessageCircle className="w-4 h-4" />
            ¿Otra duda? Escríbenos por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
